const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Format YYYY-MM-DD in the visitor's locale (UTC date parts). */
export function isoDateToDisplay(iso) {
  if (!iso || typeof iso !== 'string') return '';
  const t = iso.trim();
  if (!ISO_DATE.test(t)) return '';
  const [y, m, d] = t.split('-').map(Number);
  if (!y || !m || !d) return '';
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** Card / hero label: ISO first, then legacy display `date` string. */
export function displayNewsDate({ dateIso, date }) {
  const fromIso = isoDateToDisplay(dateIso);
  if (fromIso) return fromIso;
  if (typeof date === 'string' && date.trim()) return date.trim();
  return '';
}

export function isValidIsoDate(value) {
  if (!value || typeof value !== 'string') return false;
  return ISO_DATE.test(value.trim());
}
